import { loraItalic } from "../../styles/fonts";
import { MenuContext, MenuContextType } from ".";
import { useContext } from "react";
import NavItems from "./NavItems";
import { InstaSVG } from "@/app/icons/svgs";

export default function MobileMenuContainer() {
  const menuContext = useContext(MenuContext);
  const { menuOpen } = menuContext as MenuContextType;
  return (
    <div className="text-center">
      <div
        className={`${
          !menuOpen
            ? "hidden"
            : `fixed top-0 left-0 w-full h-full bg-white z-10 flex flex-col justify-start items-center overflow-y-auto ${loraItalic.className} text-olive text-lg xsmall:text-2xl text-olive group3:hidden`
        }`}
      >
        <NavItems />
        <a
          href="https://www.instagram.com/kkinteriordesignstudiolondon/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="open link to instagram account"
          className="pb-4"
        >
          {InstaSVG}
        </a>
      </div>
    </div>
  );
}
